import { z } from 'zod/v4';

export const UnlinkActionsParamsSchema = z.object({
  id: z.string().min(1, 'Action ID is required'),
});
export type UnlinkActionsParams = z.infer<typeof UnlinkActionsParamsSchema>;

export const UnlinkActionsRequestSchema = z.object({
  actionIds: z
    .array(z.string().min(1, 'Action ID cannot be empty'))
    .min(1, 'At least one action ID is required'),
});
export type UnlinkActionsRequest = z.infer<typeof UnlinkActionsRequestSchema>;

export const UnlinkActionsResponseSchema = z.object({
  unlinkedCount: z.number(),
});
export type UnlinkActionsResponse = z.infer<typeof UnlinkActionsResponseSchema>;
